import React, { useEffect, useState } from 'react';
import { API_BASE } from "../config";
import apiFetch from "../apiFetch";

const OwlCollectionPage = () => {
  const [owls, setOwls] = useState([]);
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const storedUserId = localStorage.getItem('userId');
    const storedUsername = localStorage.getItem('username');

    if (!storedUserId || !storedUsername) {
      setError('User not logged in');
      setLoading(false);
      return;
    }

    setUsername(storedUsername);

    apiFetch(`/api/collection?userId=${storedUserId}`)
      .then(res => res.json())
      .then(data => {
        setOwls(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('❌ Error fetching collection:', err);
        setError('Failed to load collection');
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading collection...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div style={{ padding: '20px' }}>
      <h1>{username}'s Owl Collection 🦉</h1>
      {owls.length === 0 ? (
        <p>No owls in collection yet!</p>
      ) : (
        <ul>
          {owls.map((owl) => (
            <li key={owl.id}>
              <strong>{owl.name}</strong> ({owl.rarity}) - {owl.description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default OwlCollectionPage;
